import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { eFeatures, eUserRole } from '../../../models/enum.model';
import { IntDropDownItem, SimpleResponse } from '../../../models/genericResponse.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { AssignedNumbersResponse, assignNumbersToAddList, VoiceTree, VoiceTreeListResponse, voiceTreeNumber, VoiceTreeOption, VoiceTreeOptionListResponse, VoiceTreeSetUpResponse } from '../../../models/voiceTreeList';
import { GlobalService } from '../../../services/global.service';
import { GridConfigurationService } from '../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../services/shared/utility.service';
import { VoiceCallService } from '../../../services/voice-call.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ClpCompany, CompanyResponse } from '../../../models/company.model';
import { AccountSetupService } from '../../../services/accountSetup.service';
import { NotificationService } from '../../../services/notification.service';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
@Component({
    selector: 'app-voice-tree',
    templateUrl: './voice-tree.component.html',
    styleUrl: './voice-tree.component.css',
    providers: [GridConfigurationService]
})
export class VoiceTreeComponent {
    private encryptedUser: string = '';
    showSpinner: boolean = false;
    user: CLPUser;
    userResponse: UserResponse;
    msg: string = '';
    roleFeaturePermissions: RoleFeaturePermissions;
    voiceTree: VoiceTree;
    message: string = '';
    messageType: string = '';
    voiceTreeID: number = 0;
    voiceTreeOptionID: number = 0;
    vrDDList: IntDropDownItem[];
    voiceTreeOptionList: VoiceTreeOption[];
    assignedNumbers: AssignedNumbersResponse;
    isViewMode: boolean = true;
    isEditMode: boolean = false;
    voiceTreeForm: FormGroup;
    companyData: ClpCompany = <ClpCompany>{};
    saveAsID: number = 0;
    assignNumbersList: assignNumbersToAddList[];
    vtNumberList: voiceTreeNumber[];
    @ViewChild(MatSort) sort: MatSort;
    vtNumberListSource: MatTableDataSource<any> = new MatTableDataSource([]);
    @ViewChild(MatTable) table!: MatTable<any>;
    vtNumberListDisplayColumns: string[] = [];
    columns = [
        { field: 'rowNo', title: '#', width: '50', isUIColumn: true },
        { field: 'longCodeNumber', title: 'Number', width: '100' },
        { field: 'description', title: 'Description', width: '' },
        { field: 'delete', title: 'Action', width: '80', isUIColumn: true }
    ];
    selectedOption!: VoiceTreeOption;
    isShowVTOption: boolean = false;
    selectedAssignNumber: any;
    isAddOptionVisible: boolean = true;
    isConfirmed: boolean = false;
    constructor(private fb: FormBuilder,
        private _globalService: GlobalService,
        public _localService: LocalService,
        private _utilityService: UtilityService,
        private route: ActivatedRoute,
        private _router: Router,
        public _gridCnfgService: GridConfigurationService,
        private _voiceCallService: VoiceCallService,
        private _accountSetupService: AccountSetupService,
        private _notifyService: NotificationService,
    ) {

    }

    ngOnInit(): void {
        this.voiceTreeForm = this.prepareVoiceTreeForm();
        this.voiceTreeID = +this.route.snapshot.params['vtid'] || 0;
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.getCompanyData();
                        this.voiceTreeSetUp(true);
                    }
                    else
                        this._router.navigate(['/login']);
                })
            }
            else
                this._router.navigate(['/login']);
        })
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (!isNullOrUndefined(result)) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    const response = UtilityService.clone(result);
                    if (!isNullOrUndefined(response)) {
                        if (!isNullOrUndefined(response?.user)) {
                            this.user = response.user;
                            this.roleFeaturePermissions = response.roleFeaturePermissions;
                            this._gridCnfgService.user = this.user;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("voice-tree.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this._utilityService.handleErrorResponse(err);
            });
    }

    ngAfterViewInit() {
        this.vtNumberListSource.sort = this.sort;
    }

    async voiceTreeSetUp(isNewVT: boolean = false) {
        await this._voiceCallService.voiceTreeSetUp(this.encryptedUser, this.user?.cLPCompanyID, this.user?.cLPUserID, this.voiceTreeID)
            .then(async (result: VoiceTreeSetUpResponse) => {
                if (result && result.messageBool) {
                    var response = UtilityService.clone(result);
                    this.voiceTree = response?.voiceTree;
                    if (this.voiceTree?.cLPUserID != this.user?.cLPUserID && this.user?.userRole < eUserRole.Administrator) {
                        this.isAddOptionVisible = false;
                    }
                    if (this.voiceTreeID > 0 && this.voiceTree) {
                        this.isViewMode = true;
                        this.patchVoiceTreeForm(this.voiceTree);
                        this.voiceTreeOptionList = response?.voiceTreeOptionList;
                        if (this.voiceTreeOptionList?.length > 0 || isNewVT)
                            this.onAddClick(false);
                    }
                    else {
                        this.isViewMode = false;
                        this.isEditMode = true
                        this.voiceTreeForm.patchValue({
                            name: 'Main Call Tree',
                            greetingScript: `Hello and thank you for calling ${this.companyData?.companyName}. Press 1 for sales and 2 for support.`,
                            greetingVRID: 0,
                            isRecorded: false,
                            isActive: false
                        });
                        this.onAddClick(true);
                    }
                    this.vrDDList = response?.vrDDList;
                    this.assignNumbersList = response?.assignedNumbers?.assignNumbers;
                    this.vtNumberList = response?.assignedNumbers?.vtNumberList;
                    this.setGrid(this.vtNumberList);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("voice-tree-list.voiceTreeSetUp", err.message,
                    'cLPCompanyID: ' + this.user?.cLPCompanyID + ' cLPUserID: ' + this.user?.cLPUserID + ' voiceTreeID: ' + this.voiceTreeID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    prepareVoiceTreeForm() {
        return this.fb.group({
            voiceTreeID: new FormControl(0),
            name: ['', [Validators.required]],
            script: new FormControl(""),
            greetingScript: new FormControl(""),
            greetingVRID: new FormControl(0),
            isRecorded: new FormControl(false),
            isActive: new FormControl(false)
        });
    }
    patchVoiceTreeForm(voiceTree: VoiceTree): void {
        this.voiceTreeForm.patchValue({
            voiceTreeID: voiceTree.voiceTreeID,
            name: voiceTree.name,
            greetingScript: voiceTree.greetingScript,
            greetingVRID: voiceTree.greetingVRID,
            isRecorded: voiceTree.isRecorded,
            isActive: voiceTree.isActive
        });
    }

    async voiceTreeGet(voiceTreeID: number) {
        await this._voiceCallService.voiceTreeGet(this.encryptedUser, voiceTreeID)
            .then(async (result: VoiceTree) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    if (response.voiceTreeID > 0) {
                        this.voiceTree = response;
                        this.voiceTreeID = response.voiceTreeID;
                        this.patchVoiceTreeForm(this.voiceTree);
                    }

                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async saveAs() {
        this.saveAsID = this.voiceTreeID;
        const control = this.voiceTreeForm.get('name');
        if (control) {
            const nameValue = control.value ?? '';
            control.setValue(`Copy of ${nameValue}`);
        }
        this.message = 'Please enter a name for the new Call Tree.';

    }
    async save() {
        this.VoiceTreeSaveProcess();
        this.message = 'Call Tree saved.';
    }

    async VoiceTreeSaveProcess() {
        if (this.saveAsID > 0) {

        }
        this.voiceTreeForm.markAllAsTouched();
        if (this.voiceTreeForm.valid) {
            const formValue = this.voiceTreeForm.value;

            const voiceTreeData: VoiceTree = {
                ...formValue,
                voiceTreeID: this.voiceTreeID,
                cLPCompanyID: this.user?.cLPCompanyID,
                cLPUserID: this.user?.cLPUserID,
            };
            const isNewVT = this.voiceTreeID == 0;
            await this._voiceCallService.voiceTreeSaveProcess(this.encryptedUser, this.saveAsID, voiceTreeData)
                .then(async (result: SimpleResponse) => {
                    if (result) {
                        var response = UtilityService.clone(result);
                        if (response.messageBool) {
                            this.saveAsID = 0;
                            //this.voiceTreeGet(response.messageInt);
                            this.isAddOptionVisible = isNewVT ? false : true;
                            this.voiceTreeID = response.messageInt;
                            this._notifyService.showSuccess(response.messageString, "", 3000);
                            await this.voiceTreeSetUp(isNewVT);
                            const currentId = this.route.snapshot.paramMap.get('vtid');
                            if (!currentId) {
                                this._router.navigate(['/voice-tree', this.voiceTreeID], {
                                    replaceUrl: true
                                });
                            }
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });

            this.isViewMode = true;
        }
    }

    async getCompanyData() {
        this.companyData = await this._localService.loadCompany();
        if (this.companyData == null) {
            await this._accountSetupService.getClpCompany(this.encryptedUser, this.user.cLPCompanyID)
                .then(async (result: CompanyResponse) => {
                    if (result) {
                        var response = UtilityService.clone(result);
                        this.companyData = response.company;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async VoiceTreeDelete() {
        await this._voiceCallService.voiceTreeDelete(this.encryptedUser, this.voiceTreeID, this.user.cLPUserID)
            .then(async (result: SimpleResponse) => {
                if (result && result.messageBool) {
                    this._notifyService.showSuccess('Call Tree has been deleted.', "", 3000);
                    this.isConfirmed = false;
                    this._router.navigate(['/voice-tree-list']);
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getGreetingRecName(vrId: number) {
        if (vrId && vrId > 0 && this.vrDDList && this.vrDDList.length > 0)
            return this.vrDDList?.find(x => x.id == vrId).text;
        else return '-Not Selected-';
    }

    setGrid(list: voiceTreeNumber[]) {
        this.vtNumberListDisplayColumns = this.columns.filter(col => this.isViewMode ? col.field !== 'delete' : true).map(col => col.field);
        this.vtNumberListSource.data = list;
    }

    async deleteNumber(row: voiceTreeNumber) {
        const voiceTreeNumberID = row.voiceTreeNumberID;
        if (voiceTreeNumberID && voiceTreeNumberID > 0) {

            await this._voiceCallService.voiceTreeNumberDelete(this.encryptedUser, voiceTreeNumberID)
                .then(async (result: SimpleResponse) => {
                    if (result) {
                        var response = UtilityService.clone(result);
                        if (response.messageBool) {
                            this.buildAssignedNumbers();
                            this._notifyService.showSuccess(`Call Tree Number ${row.longCodeNumber} deleted!`, "", 3000);

                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async buildAssignedNumbers() {
        await this._voiceCallService.buildAssignedNumbers(this.encryptedUser, this.user?.cLPCompanyID, this.voiceTreeID)
            .then(async (result: AssignedNumbersResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.assignNumbersList = response?.assignNumbers;
                    this.vtNumberList = response?.vtNumberList;
                    this.setGrid(this.vtNumberList);
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }


    loadOptionDetails(option: VoiceTreeOption) {
        this.selectedOption = option;
        this.isShowVTOption = true;
    }

    async getVTOptionList() {
        await this._voiceCallService.getVTOptionList(this.encryptedUser, this.voiceTreeID)
            .then(async (result: VoiceTreeOptionListResponse) => {
                if (result) {
                    const response = UtilityService.clone(result);
                    if (response.messageBool) {
                        this.voiceTreeOptionList = [...response.voiceTreeOptionList];
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }




    onAddClick(isShowVTOption: boolean = false) {
        this.isShowVTOption = isShowVTOption;
        this.selectedOption = {
            voiceTreeOptionID: 0,
            voiceTreeID: this.voiceTreeID,
            digit: 0,
            name: '',
            optionType: 0,
            optionValue: '',
            announceScript: '',
            sOrder: 0,
            dtModified: null,
            typeDisplay: '',
            valueDisplay: ''
        };
    }


    onAssignNumberChange(item: assignNumbersToAddList) {
        if (!item) return;
        this.VoiceTreeNumberUpdate(item);
    }

    async VoiceTreeNumberUpdate(assignNumber: assignNumbersToAddList) {
        const vtNum: voiceTreeNumber = {
            voiceTreeID: this.voiceTreeID,
            longCodeNumber: assignNumber?.longCodeNumber,
            description: assignNumber?.desc,
            dtCreated: new Date(),
            voiceTreeNumberID: 0
        };
        await this._voiceCallService.VoiceTreeNumberUpdate(this.encryptedUser, vtNum)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    if (response.messageBool) {
                        this.isViewMode = true;
                        this.buildAssignedNumbers();
                        //this._notifyService.showSuccess(response.messageString, "", 3000);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });

    }

    onOptionDeleted() {
        this.isShowVTOption = false;
        this.selectedOption = null;
        this.voiceTreeOptionID = 0;
        this.getVTOptionList();
    }

    get displayedColumns(): string[] {
        return this.columns
            .filter(col => this.isViewMode ? col.field !== 'delete' : true)
            .map(col => col.field);
    }

    edit() {
        this.isShowVTOption = false;
        this.isEditMode = true;
        this.message = 'Please edit Call Tree information.';
    }

    cancel() {
        this.isShowVTOption = false;
        this.message = 'No changes have been made.';
        this.isEditMode = false;
        this.isViewMode = true;
        this.voiceTreeForm.reset();
        this.patchVoiceTreeForm(this.voiceTree);
        this.saveAsID = 0;
        this.isConfirmed = false;
    }

    delete() {
        this.message = 'Please confirm this action.';
    }

    closeOption() {
        this.isShowVTOption = !this.isShowVTOption;
    }
}
